import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import CustomSubCategorySEOService from '../api/CustomSubCategorySEOService';

const initialState = {
  loading: false,
  data: [],
  error: null,
  success: false,
};

export const getCustomChildCategorySEOMethod = createAsyncThunk(`/get-customSubCategorySEO`, async () => {
  try {
    const { data } = await CustomSubCategorySEOService.get();
    return data.data;
  } catch (error) {
    console.error('-------', error.message);
    throw error;
  }
});

const customSubCategorySEOSlice = createSlice({
  name: 'customSubCategorySEO',
  initialState,
  reducers: {},
  extraReducers: {
    // get
    [getCustomChildCategorySEOMethod.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getCustomChildCategorySEOMethod.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
      state.data = payload;
    },
    [getCustomChildCategorySEOMethod.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export default customSubCategorySEOSlice.reducer;
